const springs = {
	soft: { mass: 1, tension: 80, friction: 10 }
};

export default springs;